import React from 'react';
import Tag from '@components/Tag';
import './product-item.scss';
// import { Link } from 'gatsby'

function ProductItem(props: any) {
    const { product, handleClickItem } = props;
    const {
        id,
        images,
        brand,
        nameCN,
        name,
        origin,
        merchantInfo,
        promotions,
        priceTag,
        originalPriceTag,
        priceTagCN,
        favoritedCount,
        colors
    } = product;
    return (
        <a className='m-product-item-wrapper' href={`/product/${id}/`}>
            <div className='m-product-item' data-viewtype="product" data-title='product' data-id={id}>
                <div className='img-wrap'>
                    <img src={images?.[0]?.full?.url} />
                </div>
                <div className='detail'>
                    <div className='name'>{brand ? `${brand} | ` : ''}{nameCN || name}</div>
                    <div className='origin'>{origin}{merchantInfo?.merchantName}</div>
                    <div className='sub-price'>
                        {promotions?.off &&
                            <Tag backgroundColor='#000000'>
                                {promotions?.off}
                            </Tag>
                        }
                        <div className='price-tag'>{priceTag}</div>
                        <div className='original-price-tag'>{originalPriceTag}</div>
                    </div>
                    <div className='main-price-area'>
                        <div className={`main-price ${originalPriceTag ? 'discount' : ''}`}>{priceTagCN}</div>
                        <div className='like'>{favoritedCount || 0}人收藏</div>
                    </div>
                    {promotions?.activityOffs?.length ?
                        <div className='promotion-tags'>
                            {promotions?.activityOffs?.map((item: any, index: number) => {
                                return (
                                    <div className='tag' key={index}>{item}</div>
                                )
                            })}
                        </div> : null}
                </div>
                {colors?.length ?
                    <div className='color-num'>
                        <Tag backgroundColor='#F2F2F2' fontColor='#666666'>
                            {colors?.length}色可选
                        </Tag>
                    </div> : null}
            </div>
        </a>
    )
}

export default ProductItem;